import { render } from "./StudentPlaceKey.vue?vue&type=template&id=518e639d"
import script from "./StudentPlaceKey.vue?vue&type=script&lang=js"
export * from "./StudentPlaceKey.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__